import { render, staticRenderFns } from "./forWard.vue?vue&type=template&id=304f455e&scoped=true&"
import script from "./forWard.vue?vue&type=script&lang=js&"
export * from "./forWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304f455e",
  null
  
)

export default component.exports